<template>
  <div>
    <DxDataGrid v-bind="getDefaultGridDetailProperties()" :data-source="gridSource" ref="grid"
      class="dx-card wide-card">
      <DxColumn data-field="Fecha" :caption="$t('operaciones.grid.detalle.fecha')" data-type="date" format="dd/MM/yyyy HH:mm:ss"
        width="180px" />
      <DxColumn data-field="CodigoEstado" :caption="$t('operaciones.grid.detalle.estado')"
        cell-template="estadoTemplate" width="240px">
        <DxLookup v-bind="getLookup('operaciones', 'estado')"></DxLookup>
      </DxColumn>
      <DxColumn data-field="Usuario" :caption="$t('commons.usuario')" width="240px"></DxColumn>
      <DxColumn data-field="Comentario" :caption="$t('commons.comentario')" cell-template="comentarioTemplate"></DxColumn>
      <template #estadoTemplate="{ data }">
        <div :class="[
          `d-inline-block rounded py-1 px-2`,
          `estado-operacion ${data.value}`,
        ]">
            {{ $t(`operaciones.estado.${data.value}`) }}
        </div>
      </template>
      <template #comentarioTemplate="{ data }">
        <div class="comentario-cell" :title="data.value">
          {{ data.value }}
        </div>
      </template>
    </DxDataGrid>
  </div>
</template>

<script setup lang="ts">
import { getDefaultGridDetailProperties, getLookup } from '@/.shared/helpers/grid-helper';
import { DxDataGrid, DxColumn, type DxDataGridTypes } from 'devextreme-vue/data-grid';
import { useApi } from "@api/integration";
import type CustomStore from "devextreme/data/custom_store";
import { onMounted, ref } from "vue";
import type { DXLoadOptions } from '@/.shared/.api';
import { DxLookup } from 'devextreme-vue/data-grid';

const props = defineProps<{
  templateData: DxDataGridTypes.MasterDetailTemplateData;
}>();

const api = useApi();
const gridSource = ref<CustomStore>();
const grid = ref<DxDataGrid>();

onMounted(async () => {
  gridSource.value = api.apiStore({
    key: "Id",
    load: async (p) => {
      const q = p as DXLoadOptions;

      return await api.callStandardApi("getOperacionesAguaHistoricoEstados", { showLoading: false }, q, props.templateData.key)
    }
  });
});

const reloadGrid = () => {
  grid.value?.instance?.refresh(); 
};

defineExpose({
  reloadGrid
});

</script>

<style lang="scss" scoped>


.comentario-cell {
  white-space: normal; 
  word-wrap: break-word; 
  overflow-wrap: break-word; 
  line-height: 1.5; 
}
</style>
